import React from "react"
import './ItemNotification.scss'
import { Link } from "react-router-dom"
import { BellOutlined, HddOutlined, ShareAltOutlined, ShoppingCartOutlined, TagOutlined, UpOutlined, DownOutlined } from "@ant-design/icons"
import { CHANNELTYPE, DataChannel, dataOption } from "../../services/data"
import { convertStringToHTML } from "../../until"
import { noData, user_double } from "../ExportImgFigma"
import { INotificationTemplate } from "../../api/notificationTemplate/notificationTemplateApi"
import { NO_DATA } from "../../env"
import { Tooltip } from "antd"

interface Props {
  infoNotificationTemplate?: INotificationTemplate
  link?: string,
}

const ItemNotification: React.FC<Props> = ({
  infoNotificationTemplate, link
}) => {
  const { type, adminName, createdAt, brandConfigs, providerName, typeZNSName, title, titleEmail, templateId } = infoNotificationTemplate ?? {}
  const [expandBrand, setExpandBrand] = React.useState(false)

  return (
    <Link to={link || '/'} className="t-item-notification t-item-notification-show">
      <div className="top">
        <div
          className="custom-page-css flex flex-1 items-center gap-2 w-full justify-between">
          <div className="title-block text-2-row">{DataChannel[(Number(type ?? 1) - 1)].label}</div>
          <div className=" text-2-row">{title ?? titleEmail}</div>
        </div>


        <div className="custom-page-css flex items-start justify-between">
          {
            type === CHANNELTYPE.SMS ? (
              <div className="custom-page-css flex flex-1 items-center gap-2">
                <ShareAltOutlined style={{ color: '#096DD9' }} />
                <span className="custom-page-css text-sm text-344054 font-regular">Cấu hình:</span>
              </div>
            ) : (
              <div className="custom-page-css flex flex-1 items-center gap-2">
                <ShareAltOutlined style={{ color: '#096DD9' }} />
                <span className="custom-page-css text-sm text-344054 font-regular">Loại ZNS:</span>
              </div>
            )
          }

          <span className="custom-page-css flex flex-1 text-end justify-end text-sm text-344054 font-regular">{providerName ?? typeZNSName}</span>
        </div>
        {type === CHANNELTYPE.ZNS &&
          <div className="custom-page-css flex items-start justify-between">
            <div className="custom-page-css flex flex-1 items-center gap-2">
              <ShareAltOutlined style={{ color: '#096DD9' }} />
              <span className="custom-page-css text-sm text-344054 font-regular">ID mẫu:</span>
            </div>
            <span className="custom-page-css flex flex-1 text-end justify-end text-sm text-344054 font-regular">{templateId ?? NO_DATA}</span>
          </div>
        }
        <div className="custom-page-css flex items-start  justify-between">
          <div className="custom-page-css flex flex-1 items-center gap-2">
            <img src={user_double} alt="" />
            <span className="custom-page-css text-sm text-344054 font-regular">Người tạo:</span>
          </div>
          <span className="custom-page-css flex flex-1 text-end justify-end text-sm text-344054 font-regular">{adminName}</span>
        </div>
        <div className="custom-page-css flex items-start  justify-between">
          <div className="custom-page-css flex flex-1 items-center gap-2">
            <img src={user_double} alt="" />
            <span className="custom-page-css text-sm text-344054 font-regular">Ngày tạo:</span>
          </div>
          <span className="custom-page-css flex flex-1 text-end justify-end text-sm text-344054 font-regular">{createdAt}</span>
        </div>
        <div className="custom-page-css flex items-start justify-between">
          <div className="custom-page-css flex flex-1 items-center gap-2">
            <HddOutlined style={{ color: '#096DD9' }} />
            <span className="custom-page-css text-sm text-344054 font-regular">Thương hiệu, brandname:</span>
          </div>
          <span
            className="custom-page-css flex flex-1 text-end justify-end text-sm text-344054 font-regular items-center gap-1"
            style={{ cursor: brandConfigs?.length ? 'pointer' : 'default' }}
            onClick={(e) => {
              if (brandConfigs?.length) {
                e.preventDefault()
                setExpandBrand(prev => !prev)
              }
            }}
          >
            {brandConfigs?.length ? `${brandConfigs.length} brandname` : NO_DATA}
            {!!brandConfigs?.length && (expandBrand ? <UpOutlined style={{ fontSize: 10 }} /> : <DownOutlined style={{ fontSize: 10 }} />)}
          </span>
        </div>
        {brandConfigs?.length && expandBrand ? (
          <div className="custom-page-css flex flex-col gap-1" style={{ paddingLeft: 24 }}>
            {brandConfigs.map((item, i) => (
              <div
                className="custom-page-css flex items-start justify-between"
                key={i}
              >
                <div className="custom-page-css flex flex-1 overflow-hidden">
                  <Tooltip title={item?.brandName ?? NO_DATA}>
                    <span className="text-truncate text-sm text-344054 font-regular">
                      {item?.brandName ?? NO_DATA}
                    </span>
                  </Tooltip>
                </div>
                <div className="custom-page-css flex flex-1 text-end justify-end overflow-hidden">
                  <Tooltip title={item?.categories ?? NO_DATA}>
                    <span className="text-truncate text-sm text-344054 font-regular">
                      {item?.categories ?? NO_DATA}
                    </span>
                  </Tooltip>
                </div>
              </div>
            ))}
          </div>
        ) : null}


      </div>
    </Link>
  )
}

export default ItemNotification
